<script setup lang="ts">
import { useFormStore } from '@/stores/form'
import { useUserStore } from '@/stores/user'

const formStore = useFormStore()
const userStore = useUserStore()

const gotologin = () => {
  formStore.switchForm('login')
}
async function doLogout(){
  await userStore.logout(userStore.account)
  formStore.switchForm('login')
}
const gotoVideo = ()=>{
  formStore.switchForm('video')
}
const gotoHelp = () => {
  formStore.switchForm('help')
}
const gotoAD = () => {
  formStore.switchForm('help')
}
const gotoEdituser = () => {
  formStore.switchForm('edituser')
}
const gotoApply = () => {
  formStore.switchForm('help')
}
const gotoCompany = () => {
  formStore.switchForm('company')
}
const gotoTrf = () => {
  formStore.switchForm('transfer')
  
}
</script>

<template>
  <div class="logotext">
    <!--<a href="https://video.qianchih.net">video.qianchih.net</a>-->
    <a href="https://qianchih.net" target="_blank" rel="noopener noreferrer">
    <img
      src="@/assets/QianchihLogo.jpg"
      alt="Qianchih Logo"
      width="84"
      height="84"
      class="logo"
    />
  </a>
    <!-- <a href="https://qianchih.net" target="_blank">關於虔智</a> -->
    <!-- <a href="https://video.qianchih.net/?agent=" target="_blank">video.qianchih.net</a> -->
    <!-- <a @click="gotoCompany"><h5>關於虔智</h5></a>             -->
  </div>
</template>


<style scoped>
.logotext {
  color: deeppink;
  font-size: 22px;
  margin: 20px;
}

.logotext a h5 {
  margin: -10px;
  padding: 10px;
}

.logotext a {
  color: deeppink;
  font-size: 22px;
  text-decoration: none;
  cursor: pointer;
  margin: 10px;
}
</style>
